var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('Banner'),_c('Links'),_c('Products')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }